import { camel } from 'to-case';

type CSSModulesHash = Record<string, string>;

export const createHashedClassNameGetter = (styles: CSSModulesHash) => (className: string | undefined) =>
  className ? styles[camel(className)] : '';
